import { formatUnitToFit } from '@herit-fe/heritage-common';
import type { FormattedNumberMeta } from '@herit-fe/heritage-common';

// formatInteger / formatMyriad 의 명사 suffix 상수 — 매직 스트링 제거(web·admin 공용 vocabulary).
export const SUFFIX = {
  WON: '원',
  COUNT: '개',
  DEVICE: '대',
  PERSON: '명',
  TIMES: '회',
  PERCENT: '%',
  CASE: '건',
  TEMPERATURE: '℃',
  DEGREE: '°', // 각도(방위각·경사각)

  HOUR: '시간',
  MINUTE: '분',
  DAY: '일',
  YEAR: '년',
} as const;

// 정수 + 명사 suffix(개·대·원 등) — UNIT_MAP 안 쓰는 순수 숫자 포맷. 천단위 콤마 + 정수(반올림).
// suffix 가 있으면 값과 suffix 사이에 공백('0 원'·'5 개', magnitude 단위 표기와 일관) — bare(빈 suffix)는 trailing 공백 없음.
//
// `*Meta` 는 `FormattedNumberMeta`(display·value·trailing…) 전체를 돌려주는 형제 — **숫자와 단위를 분리
// 렌더링**할 때 쓴다(예: 단위만 한 단계 작은 글꼴). display 판은 그 위에서 `.display` 만 꺼내므로 포맷 정책
// (자릿수·공백 규칙)은 여기 한 곳에만 산다.
export function formatIntegerMeta(
  value: number | null | undefined,
  suffix = '',
): FormattedNumberMeta {
  return formatUnitToFit(value, {
    suffix: { text: suffix, space: suffix !== '' },
    minDecimals: 0,
    maxDecimals: 0,
    minSignificantDigits: 0,
  });
}

export function formatInteger(value: number | null | undefined, suffix = ''): string {
  return formatIntegerMeta(value, suffix).display;
}

// 소수 N자리 고정 + 명사 suffix — 비율(%)·소수 지표(toFixed 대응). 정수는 formatInteger.
// suffix 가 있으면 값과 suffix 사이에 공백('0.00 시간'·'0.00 %') — bare(빈 suffix)는 trailing 공백 없음.
export function formatDecimalMeta(
  value: number | null | undefined,
  suffix = '',
  decimals = 2,
): FormattedNumberMeta {
  return formatUnitToFit(value, {
    suffix: { text: suffix, space: suffix !== '' },
    minDecimals: decimals,
    maxDecimals: decimals,
    minSignificantDigits: 0,
  });
}

export function formatDecimal(value: number | null | undefined, suffix = '', decimals = 2): string {
  return formatDecimalMeta(value, suffix, decimals).display;
}

// 만/억 압축표기 + 명사 suffix("90만 원" 류) — koreanMyriad 그룹핑. 정밀 표시가 필요하면 formatInteger.
export function formatMyriad(value: number | null | undefined, suffix = ''): string {
  return formatUnitToFit(value, {
    unit: 'koreanMyriad',
    suffix: { text: suffix, space: true },
  }).display;
}
